var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-badge-macros.j2"] = require( "macros/product-badge-macros.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/display-tile-badges.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-badge-macros.j2", false, "core/templates/macros/display-tile-badges.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("badgesMacro")) {
var t_4 = t_1.badgesMacro;
} else {
cb(new Error("cannot import 'badgesMacro'")); return;
}
context.setVariable("badgesMacro", t_4);
if(t_1.hasOwnProperty("browseCallOutPrimary")) {
var t_5 = t_1.browseCallOutPrimary;
} else {
cb(new Error("cannot import 'browseCallOutPrimary'")); return;
}
context.setVariable("browseCallOutPrimary", t_5);
if(t_1.hasOwnProperty("browseCallOutSecondary")) {
var t_6 = t_1.browseCallOutSecondary;
} else {
cb(new Error("cannot import 'browseCallOutSecondary'")); return;
}
context.setVariable("browseCallOutSecondary", t_6);
if(t_1.hasOwnProperty("webExclusive")) {
var t_7 = t_1.webExclusive;
} else {
cb(new Error("cannot import 'webExclusive'")); return;
}
context.setVariable("webExclusive", t_7);
if(runtime.contextOrFrameLookup(context, frame, "displayBadges")) {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")),"visualBadge") == "displaySoldOut") {
output += "<p class=\"c-product-badge c-product-badge--display-sold-out\" data-qa-badge-display-sold-out>";
output += runtime.suppressValue((lineno = 6, colno = 102, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_badge-display-sold-out"])), env.opts.autoescape);
output += "</p>";
;
}
else {
output += runtime.suppressValue((lineno = 10, colno = 21, runtime.callWrap(t_7, "webExclusive", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")])), env.opts.autoescape);
output += "\n\n        ";
output += runtime.suppressValue((lineno = 12, colno = 20, runtime.callWrap(t_4, "badgesMacro", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")),"textualBadges")])), env.opts.autoescape);
output += "\n\n        ";
output += runtime.suppressValue((lineno = 14, colno = 29, runtime.callWrap(t_5, "browseCallOutPrimary", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")])), env.opts.autoescape);
output += "\n\n        ";
output += runtime.suppressValue((lineno = 16, colno = 31, runtime.callWrap(t_6, "browseCallOutSecondary", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"product")])), env.opts.autoescape);
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/display-tile-badges.j2"] , dependencies)